import React from 'react';
import { UploadProgress } from 'app/components/UploadProgress';

export const UploadModal = () => (
  <UploadProgress message="Uploading Files..." />
);
